<i18n>
{
  "en":{
    "buttons": {
      "ok": "OK"
    },
    "config":{
      "title": "Configuration file",
      "content": "For {systemtype} system with serial number {serialnumber} and location {location}, has a configuration file has been created.",
      "checkbox": "Send configuration file to mail:",
      "mail": {
        "subject": "New Ellipse license file",
        "body": "A new Ellipse license file has been generated."
      }
    },
    "credit": {
    }
  },
  "da":{
    "buttons": {
      "ok": "OK"
    },
    "config":{
      "title": "Konfigurationsfil",
      "content": "En ny konfigurationsfil er blevet genereret for {systemtype} systemet med serienummer {serialnumber} og lokation {location}.",
      "checkbox": "Send konfigurationsfil til mail:",
      "mail": {
        "subject": "New Ellipse license file",
        "body": "A new Ellipse license file has been generated."
      }
    },
    "credit": {
    }
  }
}
</i18n>

<template>
  <b-modal ref="complete" hide-footer v-bind:title="$t(`${type}.title`)" hide-header-close>
    <div>
    {{
      $t(`${type}.content`, {
        systemtype: $t('systemtypes.' + this.system.SystemPartNumber),
        serialnumber: this.system.SerialNumber,
        location: this.system.Location
      })
    }}
    </div>
    
    <b-form-checkbox v-model="sendByMail" class="pt-4" aria-describedby="send mail" aria-controls="send mail" >
      {{ $t(`${type}.checkbox`) }} {{email}}
    </b-form-checkbox>
    <hr/>
    <b-btn class="mt-3" block variant="outline-success" @click="ok">{{$t('buttons.ok')}}</b-btn>
  </b-modal>
</template>

<script>
import elg from '../../api/elg.gateway.js'
export default {
  data() {
    return {
      sendByMail: false
    }
  },
  props: [ 'email', 'system', 'type', 'file' ],
  methods: {
    send(){
      if(!this.sendByMail){
        return Promise.resolve()
      }

      var data = {
        Recipient: this.email,
        Subject: this.$t(`${this.type}.mail.subject`),
        Body: this.$t(`${this.type}.mail.body`),
      };
      
      return elg()
      .post(`/api/v1/files/${this.file.FileID}/mail`, data);
    },
    ok(){
      this.send()
      .then( res => {
        this.$emit('accept', null);
        this.$refs['complete'].hide();
      });
    },
    show(){
      this.$refs['complete'].show();
    },
    hide(){
      
    }
  }
}
</script>


// WEBPACK FOOTER //
// WebApp/components/modals/SendConfigByMailModal.vue